var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$wf.isMdUp
    ? _c(
        "w-card",
        { staticClass: "desktop-wrapper" },
        [
          _c(
            "app-chat-wrapper",
            {
              staticClass: "desktop-chat-wrapper",
              on: {
                files: function ($event) {
                  return _vm.onFiles($event)
                },
              },
            },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.ticket.subject) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-dropdown",
                    {
                      staticClass: "mr",
                      attrs: { flat: "", items: _vm.buttonBarItems, right: "" },
                      on: {
                        click: function ($event) {
                          return _vm.trigger($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "bars" } })],
                    1
                  ),
                ],
                1
              ),
              _vm.isTicketHandled
                ? _c(
                    "div",
                    {
                      staticClass: "w-card-title",
                      style: {
                        background: "#41c391",
                        color: "#fff",
                        borderRadius: "4px",
                        margin: "15px",
                        borderBottom: "none",
                      },
                    },
                    [
                      _c("span", { staticClass: "mts" }, [
                        _vm._v(_vm._s(_vm.$ct("is-ticket-handled"))),
                      ]),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          staticClass: "light success mr",
                          attrs: { icon: "times" },
                          on: {
                            click: function ($event) {
                              return _vm.openTicket()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.no")) + " ")]
                      ),
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.closeTicket()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("common.yes")) + " ")]
                      ),
                      _vm.isTicketClosed
                        ? _c("span", [
                            _vm._v(" " + _vm._s(_vm.$ct("closed")) + " "),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("default"),
            ],
            2
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.publicLinkModal,
                callback: function ($$v) {
                  _vm.publicLinkModal = $$v
                },
                expression: "publicLinkModal",
              },
            },
            [
              _c("app-public-link", {
                attrs: { link: _vm.publicLink },
                on: {
                  cancel: function ($event) {
                    _vm.publicLinkModal = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "app-mobile-full-screen-container",
        [
          _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": "" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "w-toolbar-item",
                    { staticClass: "ml", attrs: { to: _vm.basePath } },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-toolbar-text", { staticClass: "app-title" }, [
                    _vm._v(" " + _vm._s(_vm.ticket.subject) + " "),
                  ]),
                ],
                1
              ),
              _c("w-spacer"),
              _c(
                "w-toolbar-select",
                {
                  attrs: {
                    "hide-arrow": "",
                    right: "",
                    items: _vm.buttonBarItems,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.trigger($event)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mobile-wrapper" },
            [
              _c(
                "app-chat-wrapper",
                {
                  staticClass: "mobile-chat-wrapper",
                  on: {
                    files: function ($event) {
                      return _vm.onFiles($event)
                    },
                  },
                },
                [
                  _c(
                    "w-card",
                    { staticClass: "mobile-card" },
                    [
                      _vm.isTicketHandled
                        ? _c(
                            "w-card-title",
                            {
                              style: {
                                background: "#41c391",
                                color: "#fff",
                                borderRadius: "4px 4px 0 0",
                              },
                            },
                            [
                              _c("span", { staticClass: "mts" }, [
                                _vm._v(_vm._s(_vm.$ct("is-ticket-handled"))),
                              ]),
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  staticClass: "light",
                                  style: { marginRight: "5px", color: "#fff" },
                                  attrs: { icon: "check" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeTicket()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.yes")) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "w-button",
                                {
                                  staticClass: "light",
                                  style: { color: "#308463" },
                                  attrs: { icon: "times" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openTicket()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("common.no")) + " "
                                  ),
                                ]
                              ),
                              _vm.isTicketClosed
                                ? _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$ct("closed")) + " "
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._t("default"),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.publicLinkModal,
                callback: function ($$v) {
                  _vm.publicLinkModal = $$v
                },
                expression: "publicLinkModal",
              },
            },
            [
              _c("app-public-link", {
                attrs: { link: _vm.publicLink },
                on: {
                  cancel: function ($event) {
                    _vm.publicLinkModal = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }